import useLdsCookieConsent from '../../hooks/useLdsCookieConsent.js';
import YoutubeDefault from './YoutubeDefault.jsx';

function Interstitial({
  videoId,
  consentToYoutube,
  interstitialText = `This video is hosted on YouTube, a platform which Lilly USA, LLC does
  not control, influence, or endorse. Lilly is not responsible for any
  content on this third-party site, including the privacy policy.

  Click "continue" to watch this video hosted on YouTube.`,
  buttonText = 'Continue',
}) {
  const backgroundImage = `url(https://img.youtube.com/vi/${videoId}/hqdefault.jpg)`;
  // Split the interstitial text by the newline characters to get an array of paragraphs
  const paragraphs = interstitialText.split('\n\n');

  return (
    <div
      className={'lds-youtube-video-player-interstitial active'}
      style={{ backgroundImage: backgroundImage }}
    >
      <div className="lds-youtube-video-player-interstitial-content align-center mx-0 d-flex flex-column">
        <div className="col-12 d-flex justify-center align-center">
          <lds-lilly-logo removeLink color="white"></lds-lilly-logo>
        </div>

        {/* Render each paragraph in a separate <p> tag */}
        {paragraphs.map((paragraph, index) => (
          <p key={index}>{paragraph}</p>
        ))}

        <button
          className="lds-button justify-center lds-interstitial-button"
          onClick={consentToYoutube}
        >
          {buttonText}
        </button>
      </div>
    </div>
  );
}

function YoutubeInterstitial({
  videoId,
  interstitialText,
  buttonText,
  title,
  autoplay = false,
  youtubeObjectReady,
}) {
  const { acceptCookies, cookieConsentStatus } = useLdsCookieConsent('lds_youtube_affirm');

  return (
    <div className="lds-player-wrapper with-interstitial">
      {cookieConsentStatus ? (
        <YoutubeDefault
          autoplay={autoplay}
          videoId={videoId}
          title={title}
          youtubeObjectReady={youtubeObjectReady}
        />
      ) : (
        <Interstitial
          videoId={videoId}
          consentToYoutube={acceptCookies}
          interstitialText={interstitialText}
          buttonText={buttonText}
        />
      )}
    </div>
  );
}

export default YoutubeInterstitial;
